import { AppStore } from "@alfresco/aca-shared/store";
import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { SaveViewerConfigHeaderAction } from "projects/alden-extension/src/lib/store/actions/alden.actions";

@Component({
  selector: 'smt-action-save-viewer-config-header',
  templateUrl: './save-viewer-config-header.component.html'
})
export class SaveViewerConfigHeaderComponent {
    constructor(
        private store: Store<AppStore>,
    ) { }

    saveConfigHeader() {
        this.store.dispatch(new SaveViewerConfigHeaderAction());
    }
}